import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import './ModalTrigger.scss';

class ModalTrigger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  close() {
    const { onCloseCallback } = this.props;
    this.setState({ showModal: false });
    onCloseCallback();
  }

  handleSubmit() {
    const { handleSubmit, closeAfterSubmit } = this.props;
    (handleSubmit || this.close)();
    if (closeAfterSubmit) { this.close(); }
  }

  open() {
    const { onClick } = this.props;
    onClick();
    this.setState({ showModal: true });
  }

  renderTrigger() {
    const {
      triggerType, triggerText, buttonStyles, idKey, disabled, biggerButton,
    } = this.props;
    if (triggerType === 'link') {
      return (
        <a
          className={`modal-anchor-trigger ${buttonStyles}`}
          tabIndex={0}
          role="button"
          onClick={this.open}
          id={`${idKey}-link`}
          disabled={disabled}
          href="#modal-trigger-open"
        >
          {triggerText}
        </a>
      );
    }
    return (
      <Button
        variant={buttonStyles}
        className={`${biggerButton ? 'bigger-button' : ''}`}
        onClick={this.open}
        id={`${idKey}-button`}
        disabled={disabled}
      >
        {triggerText}
      </Button>
    );
  }

  renderSubTitle() {
    const { subTitle } = this.props;

    if (subTitle !== '') {
      return (
        <h5>{subTitle}</h5>
      );
    }
    return null;
  }

  renderSubmit() {
    const {
      idKey,
      submitButtonText,
      submitButtonStyle,
      submitDisabled,
      submitButtonNode,
    } = this.props;

    if (submitButtonNode === null) {
      return (
        <Fragment>
          { submitButtonText && (
          <Button
            disabled={submitDisabled}
            variant={submitButtonStyle || 'primary'}
            onClick={this.handleSubmit}
            id={`${idKey}-confirm`}
          >
            {submitButtonText}
          </Button>
          )}
        </Fragment>
      );
    }

    return submitButtonNode;
  }

  renderFooter() {
    const {
      showFooter,
      cancelButton,
      cancelButtonText,
      idKey,
      showWithdrawButton,
      submitButtonText,
      handleWithdrawApplication,
    } = this.props;

    if (showFooter === true) {
      return (
        <Modal.Footer className="style-guide d-flex justify-content-center">
          { idKey === 'consultant-interest-application'
            ? (
              <Fragment>
                <div className="footer-action">
                  { cancelButton
                  && (
                  <Button variant="default" id={`${idKey}-close`} onClick={this.close}>
                    {cancelButtonText}
                  </Button>
                  )}
                  { (showWithdrawButton || submitButtonText === 'Submit application')
                  && this.renderSubmit()}
                </div>
                { showWithdrawButton
                && (
                <div className="footer-action">
                  <Button
                    id="btn-withdraw"
                    variant="danger"
                    onClick={() => handleWithdrawApplication()}
                  >
                    Withdraw
                  </Button>
                </div>
                )}
              </Fragment>
            )
            : (
              <Fragment>
                { cancelButton && <Button variant="default" id={`${idKey}-close`} onClick={this.close}>{cancelButtonText}</Button>}
                { this.renderSubmit()}
              </Fragment>
            )}
        </Modal.Footer>
      );
    }

    return null;
  }

  render() {
    const {
      headerTitle,
      showHeader,
      idKey,
      animation,
      dialogClassName,
      cloneContent,
      children,
      modalSize,
    } = this.props;
    const { showModal } = this.state;

    return (
      <div className="modal-trigger">
        {this.renderTrigger()}

        <Modal
          show={showModal}
          onHide={this.close}
          id={idKey}
          animation={animation}
          dialogClassName={dialogClassName}
          size={modalSize}
        >
          {
            showHeader && (
              <Modal.Header closeButton>
                <Modal.Title>
                  {headerTitle}
                </Modal.Title>
                { this.renderSubTitle()}
              </Modal.Header>
            )
          }
          <Modal.Body>
            {cloneContent
              ? React.cloneElement(children, { closeModal: this.close })
              : children}
          </Modal.Body>
          {this.renderFooter()}
        </Modal>
      </div>
    );
  }
}

ModalTrigger.propTypes = {
  submitButtonText: PropTypes.string,
  submitButtonStyle: PropTypes.string,
  cancelButton: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  triggerText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  buttonStyles: PropTypes.string,
  headerTitle: PropTypes.string,
  subTitle: PropTypes.string,
  handleSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
  triggerType: PropTypes.oneOf(['link', 'button']),
  children: PropTypes.node.isRequired,
  idKey: PropTypes.string.isRequired,
  showFooter: PropTypes.bool,
  showHeader: PropTypes.bool,
  animation: PropTypes.bool,
  disabled: PropTypes.bool,
  closeAfterSubmit: PropTypes.bool,
  biggerButton: PropTypes.bool,
  onCloseCallback: PropTypes.func,
  submitButtonNode: PropTypes.node,
  onClick: PropTypes.func,
  dialogClassName: PropTypes.string,
  cloneContent: PropTypes.bool,
  showModal: PropTypes.bool,
  showWithdrawButton: PropTypes.bool,
  handleWithdrawApplication: PropTypes.func,
  modalSize: PropTypes.string,
};

ModalTrigger.defaultProps = {
  submitButtonText: '',
  submitButtonStyle: null,
  cancelButton: true,
  cancelButtonText: 'Close',
  triggerText: '',
  buttonStyles: '',
  headerTitle: '',
  subTitle: '',
  handleSubmit: null,
  submitDisabled: false,
  triggerType: 'button',
  showHeader: true,
  showFooter: true,
  animation: true,
  disabled: false,
  closeAfterSubmit: false,
  biggerButton: false,
  onCloseCallback: () => null,
  submitButtonNode: null,
  onClick: () => null,
  dialogClassName: '',
  cloneContent: false,
  showModal: false,
  showWithdrawButton: false,
  handleWithdrawApplication: () => {},
  modalSize: 'lg',
};

export default ModalTrigger;
